<template>
  <div class="indicator-container">
    <ListHeader :title="data.name || '三级维度指标'">
      <template slot="right">
        <ActionButton :on-click="handleActionClick"/>
      </template>
    </ListHeader>
    <div class="indicator-content">
      <div class="score-box">
        <Score :score="data.score || 0" :maxScore="data.maxScore || 0"/>
      </div>
      <div class="divider"></div>
      <div class="chart-box">
        <EvidenceChart :gain="data.gainList" :loss="data.lossList" height="180px"></EvidenceChart>
      </div>
    </div>
  </div>
</template>
<script>
import ListHeader from '@/components/ListHeader.vue';
import Score from './Score.vue';
import * as echarts from 'echarts';
import ActionButton from './ActionButton.vue';
import EvidenceChart from "@/pages/screen/components/EvidenceChart.vue";

export default {
  name: 'ReportStyle3',
  components: {
    EvidenceChart,
    ListHeader,
    Score,
    ActionButton,
  },
  props: {
    data: {
      type: Object,
      default: null
    },

    onClick: {
      type: Function,
      default: () => {
      }
    }
  },
  data() {
    return {
      chartData: {
        categories: ['导入', '讲解', '互动', '练习', '总结'],
        values: [85, 92, 88, 90, 95]
      }
    };
  },
  mounted() {
    window.addEventListener('resize', this.resizeChart);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resizeChart);
  },
  methods: {
    resizeChart() {
    },
    handleActionClick(type) {
      if (this.onClick) {
        this.onClick(type, this.data);
      } else {
        console.log(`在ReportStyle4中点击了${type}按钮`);
      }
    },
  }
}
</script>
<style lang="less" scoped>
@import '@/assets/css/common-indicator.less';

.indicator-container {
  .indicator-content {


    .text-box {
      width: 400px;

    }

    .chart-container {
      .line-chart {
        width: 100%;
        height: 100%;
      }
    }

  }
}
</style>
